module.exports = __webpack_public_path__ + "static/media/plane(25).b9b857cc.PNG";